import { render, staticRenderFns } from "./IBanlance.vue?vue&type=template&id=d8d12400&scoped=true&"
import script from "./IBanlance.vue?vue&type=script&lang=js&"
export * from "./IBanlance.vue?vue&type=script&lang=js&"
import style0 from "./IBanlance.vue?vue&type=style&index=0&id=d8d12400&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d12400",
  null
  
)

export default component.exports